import { contactList } from './data';
export default {
  name: 'social-contact',
  data: function data() {
    return {
      contactList: contactList
    };
  }
};